import CaptivateImageGridFour from './CaptivateImageGridFour';
import CaptivateImageGridThree from './CaptivateImageGridThree';
import CaptivateLandscapeImage from './ImageOrientation/CaptivateLandscapeImg';

const CaptivateImageGridEight = ({
  dataList = [],
  variation = 1,
  updateCarouselState = imageNo => {},
}) => {
  if (!dataList.length || dataList.length !== 8) return null;

  return (
    <>
      {variation % 2 !== 0 && (
        <>
          <CaptivateImageGridFour
            dataList={dataList.slice(0, 4)}
            variation={variation}
            updateCarouselState={updateCarouselState}
          />
          <CaptivateImageGridThree
            dataList={dataList.slice(4, 7)}
            variation={variation}
            updateCarouselState={updateCarouselState}
          />
          <CaptivateLandscapeImage
            dataList={dataList.slice(7)}
            updateCarouselState={updateCarouselState}
          />
        </>
      )}

      {variation % 2 === 0 && (
        <>
          <CaptivateImageGridThree
            dataList={dataList.slice(4, 7)}
            variation={variation}
            updateCarouselState={updateCarouselState}
          />
          <CaptivateImageGridFour
            dataList={dataList.slice(0, 4)}
            variation={variation}
            updateCarouselState={updateCarouselState}
          />
          <CaptivateLandscapeImage
            dataList={dataList.slice(7)}
            updateCarouselState={updateCarouselState}
          />
        </>
      )}
    </>
  );
};

export default CaptivateImageGridEight;
